import { render, staticRenderFns } from "./qiyeyun.vue?vue&type=template&id=237c2cb0&scoped=true"
import script from "./qiyeyun.vue?vue&type=script&lang=js"
export * from "./qiyeyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c2cb0",
  null
  
)

export default component.exports